import { map } from 'rxjs/operators';
import { Component, OnInit, Input } from '@angular/core';
import { DVFormArray, DVFormGroup, DVFormControl } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SnotifyService } from 'ng-snotify';
import _ from 'lodash';
import moment from 'moment';
import { ExperiencesService } from '../experiences.service';

@Component({
  selector: 'app-add-image-alt',
  templateUrl: './add-image-alt.component.html',
  styleUrls: ['./add-image-alt.component.css']
})
export class AddImageAltComponent implements OnInit {
  experienceForm: DVFormGroup;
  isAddState = true;
  imageAlts: [];
  days: [];
  experienceData: any;
  constructor(
    public route: ActivatedRoute,
    private experienceApi: ExperiencesService,
    private notifier: SnotifyService,
    private router: Router
  ) {
    this.experienceForm = new DVFormGroup({
      id: new DVFormControl(null),
      ExperiencePictures: new DVFormGroup({
        id: new DVFormControl(),
        url: new DVFormControl(),
        alt: new DVFormControl(),
      })
    });
  }

  ngOnInit() {
    this.initiateAltImageMode();
  }

  formSubmit(active?: boolean) {
    if (this.experienceForm.valid) {
      const formResult = this.experienceForm.getCleanValue();
      delete this.experienceData.experience.price;
      delete this.experienceData.experience.picture;
      delete this.experienceData.experience.pictureAlt;
      delete this.experienceData.experience.adminApproval;
      delete this.experienceData.experience.index;
      delete this.experienceData.experience.verified;
      delete this.experienceData.experience.createdBy;
      delete this.experienceData.experience.locationId;
      delete this.experienceData.experience.createdAt;
      delete this.experienceData.experience.updatedAt;
      delete this.experienceData.experience.deletedAt;
      delete this.experienceData.experience.Tags;
      delete this.experienceData.experience.Accommodations;
      delete this.experienceData.experience.RelatedExperiences;
      delete this.experienceData.experience.City;
      delete this.experienceData.experience.Locals;
      delete this.experienceData.experience.ExperienceTypes;
      delete this.experienceData.experience.OnlineExperienceDetails;

      delete this.experienceData.experience.ExperienceCancellationPolicies;
      delete this.experienceData.experience.Location;
      delete this.experienceData.experience.Price;
      delete this.experienceData.experience.active;
      delete this.experienceData.experience.cityId;
      delete this.experienceData.experience.createdAt;
      delete this.experienceData.experience.createdBy;
      delete this.experienceData.experience.deletedAt;
      delete this.experienceData.experience.description;
      delete this.experienceData.experience.discount;
      delete this.experienceData.experience.duration;
      delete this.experienceData.experience.endDate;
      delete this.experienceData.experience.excluded;
      delete this.experienceData.experience.facts;
      delete this.experienceData.experience.highlights;
      delete this.experienceData.experience.included;

      delete this.experienceData.experience.index;
      delete this.experienceData.experience.maximumCapacity;
      delete this.experienceData.experience.metaDescription;
      delete this.experienceData.experience.metaKeywords;
      delete this.experienceData.experience.metaTitle;
      delete this.experienceData.experience.name;

      delete this.experienceData.experience.startDate;
      delete this.experienceData.experience.startIndex;
      delete this.experienceData.experience.tagline;
      delete this.experienceData.experience.updatedAt;
      delete this.experienceData.experience.verified;
      delete this.experienceData.experience.videoUrl;
      console.log( this.experienceData , ">>>>>>>>>");

      this.performEditOperation( this.experienceData.experience, this.experienceData.experience.id);
    } else {
      this.experienceForm.forceShowErrors();
    }
  }


  private initiateAltImageMode() {
    const experienceId = this.route.snapshot.params.id;
    this.experienceApi.getSingleExperienceById(experienceId).subscribe(response => {
      const experienceBody = response.data.experience;
      this.experienceData = response.data;
      // this.experienceData.experienceTypes = this.experienceData.ExperienceTypes;
      this.imageAlts = experienceBody.ExperiencePictures;
      this.days = experienceBody.ExperienceDays
      console.log('Experience Body >>> ', response.data);
      this.imageAlts = experienceBody.ExperiencePictures.map((day, index) => ({
        id: day.id,
        url: day.url,
        alt: day.alt
      }));

      this.experienceForm.patchValue(experienceBody);
    });
  }

  addAlt (event) {
    const formResult = this.experienceForm.getCleanValue();
    const altTitle = event.target.value;
    const imageId = event.target.id;
    // console.log(this.experienceData, 'rrrrrrrrrrrrr', altTitle, imageId);
    for (let index = 0; index < this.experienceData.experience.ExperiencePictures.length; index++) {
      const image = this.experienceData.experience.ExperiencePictures[index];
      if (image.id == imageId) {
        this.experienceData.experience.ExperiencePictures[index].alt = altTitle;
        return;
      }
    }
  }

  addAltActivity (event) {
    const formResult = this.experienceForm.getCleanValue();
    const altTitle = event.target.value;
    const imageId = event.target.id;
    // console.log(this.experienceData, 'rrrrrrrrrrrrr', altTitle, imageId);
    for (let index = 0; index < this.experienceData.experience.ExperienceDays.length; index++) {
      const day = this.experienceData.experience.ExperienceDays[index];
      for (let index2 = 0; index2 < day.Activities.length; index2++) {
        const activity = day.Activities[index2];
        for (let index3 = 0; index3 < activity.Pictures.length; index3++) {
          const image = activity.Pictures[index3];
          console.log('image', image, imageId);
          if (image.id == imageId) {
            this.experienceData.experience.ExperienceDays[index].Activities[index2].Pictures[index3].alt = altTitle;
            console.log(this.experienceData.experience.ExperienceDays[index].Activities[index2].Pictures[index3]);
            return;
          }
        } 
        console.log(this.experienceData.experience, 'aaaaaaaaaa');
        
      }
      
    }
  }
  private performEditOperation(experienceFormBody, experienceId) {
    this.experienceApi.updateExperiencePicture(experienceFormBody, experienceId).subscribe(response => {
      this.notifier.success('Experience Editted Successfully');
      this.router.navigate(['/experiences/list']);
    }, error => {
      this.notifier.error(error.error.userMessage);
    });
  }

}
export class AttachedFileModel {
  id: string;
  name: string;
  type: string;
  /**
   *
   */
  constructor() {
    this.id = '';
    this.name = '';
    this.type = '';
  }
}
interface DateClickInterface {
  alt: string;
  jsEvent: MouseEvent;
}